import axios from "axios";
import { store } from "../store";
import { UPDATE_AUTH, EMPTY_AUTH } from "../store/actionTypes";
import SHOW_TOAST, { SHOW_INTERNET_TOAST } from "./showToast";

/**
 * @var status_code
 * @description Defined all static API status Code
 * all about our axios setup
 */
export const status_code = {
  success: 200,
  invalid: 400,
  timeout: 408,
  notFound: 204,
  badRequest: 400,
  userDelete: 410,
  serverError: 500,
  Unauthorized: 401,
  successAction: 201,
};

const successCodes = [200, 201];
const sessionExpiryCodes = [403, 401];

/**
 * create axios instance
 */
const $http = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    deviceid: "testId",
  },
});

const $httpFileUpload = axios.create({
  timeout: 30000,
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  headers: {
    "Content-Type": "multipart/form-data",
    deviceid: " ",
  },
});

$http.interceptors.request.use(async (config) => {
  if (config.headers) {
    const getState = store?.getState();
    if (getState) {
      const { accessToken = "" } = getState.AuthReducer;
      if (accessToken && accessToken.length > 0) {
        config.headers["Authorization"] = `bearer ${accessToken}`;
      }
      return config;
    }
    return config;
  }
  return config;
});

const onResponse = (response) => {
  return response;
};

const onErrorResponse = (error) => {
  if (axios.isAxiosError(error)) {
    const { status } = error.response ?? {};
    switch (status) {
      case 400: {
        break;
      }
      case 401: {
        sessionExpireHandler();
        console.log("401 || UNAUTHORIZED ACCESS");
        break;
      }
      case 403: {
        console.log("403 || ERROR");
        break;
      }
      case 404: {
        console.log("404 || API NOT FOUND");
        break;
      }
      case 500: {
        console.log("500 || SERVER ERROR");
        break;
      }
      default: {
        console.log("Network Error");
        break;
      }
    }
  }
  return Promise.reject(error);
};

$http.interceptors.response.use(onResponse, onErrorResponse);

const sessionExpireHandler = () => {
  store.dispatch({ type: EMPTY_AUTH, payload: { isLoading: false } });
  // sessionStorage.clear();
};

/**
 * post api call common function
 * @param endPoint endpoint of api
 * @param params data to send
 * @param callback callback function
 */
export const POST_API_CALL = (endPoint, params, callback) => {
  $http
    .post(endPoint, params)
    .then((response) => {
      if (
        response &&
        response?.status &&
        successCodes.includes(response?.status)
      ) {
        let dataToSend = response?.data?.data || response?.data;
        callback({
          isSuccess: true,
          data: { ...dataToSend, ...{ message: response?.data?.message } },
        });
      } else {
        SHOW_TOAST(response?.data?.message);
        callback({ isSuccess: false, data: response?.response?.data });
      }
    })
    .catch((error) => {
      if (error?.response) {
        //if error contains response
        const statusCode =
          error?.response?.status || error?.response?.data?.status;

        let message = error?.response?.data?.message;
        if (Array.isArray(message)) {
          message = message[0];
        }

        if (sessionExpiryCodes.includes(statusCode)) {
          //session expired
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
          sessionExpireHandler();
        } else {
          //some other error is there
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
        }
      } else if (!error.response) {
        //if error does not contain response
        if (error?.code === "ERR_NETWORK") {
          SHOW_INTERNET_TOAST();
        } else {
          SHOW_TOAST();
        }
        callback({ isSuccess: false, data: {} });
      }
    });
};

export const PUT_API_CALL = (endPoint, params, callback) => {
  $http
    .put(endPoint, params)
    .then((response) => {
      if (
        response &&
        response?.status &&
        successCodes.includes(response?.status)
      ) {
        let dataToSend = response?.data?.data || response?.data;
        callback({
          isSuccess: true,
          data: { ...dataToSend, ...{ message: response?.data?.message } },
        });
      } else {
        SHOW_TOAST(response?.data?.message);
        callback({ isSuccess: false, data: response?.response?.data });
      }
    })
    .catch((error) => {
      if (error?.response) {
        console.log("Error :", error);
        //if error contains response
        const statusCode =
          error?.response?.status || error?.response?.data?.status;

        let message = error?.response?.data?.error;
        if (Array.isArray(message)) {
          message = message[0];
        } else message = error?.response?.data?.message;

        if (sessionExpiryCodes.includes(statusCode)) {
          //session expired
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
          sessionExpireHandler();
        } else {
          //some other error is there
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
        }
      } else if (!error.response) {
        //if error does not contain response
        if (error?.code === "ERR_NETWORK") {
          SHOW_INTERNET_TOAST();
        } else {
          SHOW_TOAST();
        }
        callback({ isSuccess: false, data: {} });
      }
    });
};
export const GET_API_CALL = (endPoint, params, callback) => {
  $http
    .get(endPoint + params, {})
    .then((response) => {
      if (
        response &&
        response?.status &&
        successCodes.includes(response?.status)
      ) {
        let dataToSend = response?.data?.data || response?.data;
        callback({
          isSuccess: true,
          data: { ...dataToSend, ...{ message: response?.data?.message } },
        });
      } else {
        console.log("toast from success");
        SHOW_TOAST(response?.data?.message);
        callback({ isSuccess: false, data: response?.response?.data });
      }
    })
    .catch((error) => {
      if (error?.response) {
        //if error contains response
        const statusCode =
          error?.response?.status || error?.response?.data?.status;

        let message = error?.response?.data?.error?.message;
        if (Array.isArray(message)) {
          message = message[0];
        }

        if (sessionExpiryCodes.includes(statusCode)) {
          //session expired
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
          sessionExpireHandler();
        } else {
          //some other error is there
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
        }
      } else if (!error.response) {
        //if error does not contain response
        if (error?.code === "ERR_NETWORK") {
          SHOW_INTERNET_TOAST();
        } else {
          SHOW_TOAST();
        }
        callback({ isSuccess: false, data: {} });
      }
    });
};

export const DELETE_API_CALL = (endPoint, callback) => {
  $http
    .delete(endPoint)
    .then((response) => {
      if (
        response &&
        response?.status &&
        successCodes.includes(response?.status)
      ) {
        let dataToSend = response?.data?.data || response?.data;
        callback({
          isSuccess: true,
          data: { ...dataToSend, ...{ message: response?.data?.message } },
        });
      } else {
        SHOW_TOAST(response?.data?.message);
        callback({ isSuccess: false, data: response?.response?.data });
      }
    })
    .catch((error) => {
      console.log("error in delete :", error);
      if (error?.response) {
        const statusCode =
          error?.response?.status || error?.response?.data?.status;

        let message = error?.response?.data?.errors?.message;
        if (Array.isArray(message)) {
          message = message[0];
        }

        if (sessionExpiryCodes.includes(statusCode)) {
          //session expired
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
          // sessionExpireHandler();
        } else {
          //some other error is there
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
        }
      } else if (!error.response) {
        //if error does not contain response
        if (error?.code === "ERR_NETWORK") {
          SHOW_INTERNET_TOAST();
        } else {
          SHOW_TOAST();
        }
        callback({ isSuccess: false, data: {} });
      }
    });
};

/**
 * patch api call common function
 * @param endPoint endpoint of api
 * @data data to send
 * @param callback callback function
 */
export const PATCH_API_CALL = (endPoint, data, callback) => {
  $http
    .patch(endPoint, data)
    .then((response) => {
      if (
        response &&
        response?.status &&
        successCodes.includes(response?.status)
      ) {
        let dataToSend = response?.data?.data || response?.data;
        callback({
          isSuccess: true,
          data: { ...dataToSend, ...{ message: response?.data?.message } },
        });
      } else {
        SHOW_TOAST(response?.data?.message);
        callback({ isSuccess: false, data: response?.response?.data });
      }
    })
    .catch((error) => {
      if (error?.response) {
        //if error contains response
        const statusCode =
          error?.response?.status || error?.response?.data?.status;

        let message = error?.response?.data?.error;
        if (Array.isArray(message)) {
          message = message[0];
        }

        if (sessionExpiryCodes.includes(statusCode)) {
          //session expired
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
          sessionExpireHandler();
        } else {
          //some other error is there
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
        }
      } else if (!error.response) {
        //if error does not contain response
        if (error?.code === "ERR_NETWORK") {
          SHOW_INTERNET_TOAST();
        } else {
          SHOW_TOAST();
        }
        callback({ isSuccess: false, data: {} });
      }
    });
};

/**
 * post api call common function
 * @param endPoint endpoint of api
 * @param params data to send
 * @param callback callback function
 */
export const POST_API_FILE_UPLOAD_CALL = (endPoint, params, callback) => {
  $httpFileUpload
    .post(endPoint, params)
    .then((response) => {
      if (response && response?.status === 204) {
        let dataToSend = response;
        callback({
          isSuccess: true,
          data: { ...dataToSend, ...{ message: response?.data?.message } },
        });
      } else {
        SHOW_TOAST("SOMETHING WENT WRONG IN FILE UPLOAD");
        callback({ isSuccess: false, data: response?.response?.data });
      }
    })
    .catch((error) => {
      if (error?.response) {
        //if error contains response
        const statusCode =
          error?.response?.status || error?.response?.data?.status;

        let message = error?.response?.data?.message;
        if (Array.isArray(message)) {
          message = message[0];
        }

        if (sessionExpiryCodes.includes(statusCode)) {
          //session expired
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
          sessionExpireHandler();
        } else {
          //some other error is there
          SHOW_TOAST(message);
          callback({ isSuccess: false, data: {} });
        }
      } else if (!error.response) {
        //if error does not contain response
        if (error?.code === "ERR_NETWORK") {
          SHOW_INTERNET_TOAST();
        } else {
          SHOW_TOAST();
        }
        callback({ isSuccess: false, data: {} });
      }
    });
};
